import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  IconButton,
  Box,
  CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import TerminalOrangeButton from '../ui/TerminalOrangeButton';
import { useGetCatalogBrowseQuery } from '../../store/api/stocktakeApi';

const ProductPickerDialog = ({ open, stocktakeId, onClose, onSelectProduct }) => {
  const [search, setSearch] = useState('');
  const [parentId, setParentId] = useState(null);
  const [parentStack, setParentStack] = useState([]);

  useEffect(() => {
    if (!open) {
      setSearch('');
      setParentId(null);
      setParentStack([]);
    }
  }, [open]);

  const trimmedSearch = search.trim();
  const { data, isFetching } = useGetCatalogBrowseQuery(
    {
      stocktakeId,
      parentId: trimmedSearch ? undefined : parentId,
      search: trimmedSearch || undefined,
    },
    { skip: !open || !stocktakeId }
  );

  const categories = data?.categories || [];
  const products = data?.products || [];

  const enterCategory = (cat) => {
    setParentStack((prev) => [...prev, parentId]);
    setParentId(cat.id);
    setSearch('');
  };

  const goBack = () => {
    setParentStack((prev) => {
      if (prev.length === 0) {
        setParentId(null);
        return prev;
      }
      const next = [...prev];
      const prevParent = next.pop();
      setParentId(prevParent ?? null);
      return next;
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 1 }}>
        {parentId != null && !trimmedSearch ? (
          <IconButton aria-label="назад" onClick={goBack} edge="start">
            <ArrowBackIcon />
          </IconButton>
        ) : null}
        <Typography variant="h6" component="span" sx={{ flex: 1 }}>
          Додати товар
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          size="small"
          label="Пошук"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2 }}
        />
        {isFetching ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <List dense disablePadding>
            {!trimmedSearch
              ? categories.map((cat) => (
                  <ListItemButton key={`cat-${cat.id}`} onClick={() => enterCategory(cat)}>
                    <FolderOutlinedIcon sx={{ mr: 1.5, color: 'text.secondary' }} />
                    <ListItemText primary={cat.name} />
                  </ListItemButton>
                ))
              : null}
            {products.map((p) => (
              <ListItemButton
                key={`prod-${p.id}`}
                onClick={() => onSelectProduct(p)}
                sx={p.inStocktake ? { bgcolor: 'rgba(46, 125, 50, 0.08)' } : undefined}
              >
                <ListItemText
                  primary={`${p.name || ''} ${p.modName || ''}`.trim()}
                  secondary={
                    <>
                      {p.article ? `Арт: ${p.article}` : null}
                      {p.inStocktake ? ` · Факт: ${p.quantityActual}` : null}
                    </>
                  }
                />
              </ListItemButton>
            ))}
            {!categories.length && !products.length ? (
              <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
                Нічого не знайдено
              </Typography>
            ) : null}
          </List>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <TerminalOrangeButton onClick={onClose}>Закрити</TerminalOrangeButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProductPickerDialog;
